import alerts from "./alerts.json";
import form from "./form.json";

const MarketCodeConfig = {
    alerts,
    form,
};

export default MarketCodeConfig;